import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { PhoneNumberService } from '../../service/phone-number-validation';

@UntilDestroy()
@Component({
  selector: 'auth-prompt-page',
  templateUrl: './auth-prompt-page.component.html',
  styleUrls: ['./auth-prompt-page.component.scss'],
})
export class AuthPromptPageComponent implements OnInit {
  constructor(
    private appService: AppService,
    private phoneNumberService: PhoneNumberService,
  ) {}

  /** 当前手机区号 */
  @Input() currentPhoneZone: any;
  /** 当前手机号 */
  @Input() phoneNum: any;
  @Output() complete: EventEmitter<any> = new EventEmitter();

  isCorrect = false;
  /** 用户输入的后六位手机号 */
  inputPhoneNum = '';
  /**展示错误*/
  showError = false;
  ngOnInit(): void {
    // 获取用户信息
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(x => {
      if (!x) return;
      if (x.mobile != null) {
        if (!this.phoneNum) this.phoneNum = x.mobile;
      }
    });
    this.appService.currentCountry$
      .pipe(
        untilDestroyed(this),
        filter(x => x),
      )
      .subscribe(x => {
        if (!this.currentPhoneZone) this.currentPhoneZone = x.areaCode;
      });

    console.log('in authPromot:', this.phoneNum, this.currentPhoneZone);
  }

  // 關閉
  dismiss() {
    const index = this.phoneNum.indexOf('*');
    //获取*之前号码
    const firstPart = this.phoneNum.substring(0, index);
    //拼接完整手机号
    const fullPhoneNumber = `${firstPart}${this.inputPhoneNum}`;
    const isVaild = this.phoneNumberService.checkVaild(fullPhoneNumber, this.currentPhoneZone);
    if (!isVaild) {
      this.showError = true;
      return;
    }
    this.showError = false;
    this.complete.emit(fullPhoneNumber);
    return;
  }

  /**
   * 輸入中
   *
   * @param code
   */
  onCodeChanged(code: string) {
    this.inputPhoneNum = code;
    if (this.inputPhoneNum.length < 6) {
      this.isCorrect = false;
    }
  }

  /**
   * 輸入完畢
   *
   * @param code
   */
  onCodeCompleted(code: string) {
    this.inputPhoneNum = code;
    if (this.inputPhoneNum.length == 6) {
      this.isCorrect = true;
    }
  }

  //取消
  close() {
    this.complete.emit('CLOSE');
  }
}
